<template>
  <div class="main-body--content">
    <div class="main-body--left">
      <div class="same-day-revenue">
        <span class="revenue">今日总体营收</span>
        <span class="money">{{ $cUtils.format.numberSplitWithComma(totalIncomeToday.totalIncome) }}</span>
        <span class="speed-up"><i class="icon el-icon-caret-top"></i>{{ (totalIncomeToday.riseRate * 100).toFixed(0) }}%</span>
        <span class="time">{{ $cUtils.format.formatDate(new Date(totalIncomeToday.date),'yyyy-MM-dd') }}</span>
      </div>
      <c-block-box title="项目基本信息" class="margin-bottom-1rem">
        <div class="essential-info">
          <div class="essential-info--box">
            <span class="lable">价值目标</span>
            <span class="value">{{ projectDetail.targetEvaluation }}</span>
          </div>
          <div class="essential-info--box">
            <span class="lable">项目周期</span>
            <span class="value">{{ projectDetail.projectCycle }}</span>
          </div>
          <div class="essential-info--box">
            <span class="lable">验证周期</span>
            <span class="value">{{ projectDetail.verificationCycle }}</span>
          </div>
          <div class="essential-info--box">
            <span class="lable">项目成员</span>
            <span class="value">{{ projectDetail.projectMember }}</span>
          </div>
        </div>
      </c-block-box>
      <c-block-box :title="`业务核心指标-${simpleOption.title}`">
        <div style="height: 22.1rem">
          <simple height="22.1rem" :option="simpleOption.data" v-if="simpleOption.data"></simple>
        </div>
      </c-block-box>
    </div>
    <div class="main-body--right">
      <c-block-box :title="`项目价值评估（影响用户占比：${projectEvaluation.affectUser || 0} %）`" class="margin-bottom-1rem">
        <div class="project-box">
          <div class="project-assessment">
            <div
              class="flex"
              v-for="(item, index) in projectEvaluation.data"
              :key="index"
            >
              <div class="flex-header">{{ item.indicatorName }}</div>
              <div class="flex-body">
                <div class="line">
                  <div class="lable">原始值</div>
                  <div class="value">{{ parseFloat((item.originalValue * 100).toFixed(2)) }}%</div>
                </div>
                <div class="line">
                  <div class="lable">项目预期</div>
                  <div class="value">{{ parseFloat((item.projectExpected * 100).toFixed(2)) }}%</div>
                </div>
                <div class="line">
                  <div class="lable">验证结果</div>
                  <div class="value">{{ parseFloat((item.validationResult * 100).toFixed(2)) }}%<span v-if="item.riseRate">(+{{ parseFloat((item.riseRate * 100).toFixed(2)) }}%)</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="project-tips">
            <div class="project-tips--title">备注：</div>
            <div class="project-tips--content">
              1.各项数据在项目验证周期长度内取平均值；2.项目CTR提升对整体业务的影响以付费转化率的提升比率表示；3.验证结果在项目验证周期结束后更新
            </div>
          </div>
        </div>
      </c-block-box>
      <c-block-box :title="`项目核心指标-${optionItem.title}`">
        <div style="height: 22.1rem;padding: 0 1.5rem">
          <ChartBarLine
            id="iuiehege"
            height="22.1rem"
            :option="optionItem.data"
            v-if="optionItem.data"
          ></ChartBarLine>
        </div>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import simple from '@/components/echarts/simple'
import ChartBarLine from '@/components/echarts/line'
export default {
  components: {
    simple,
    ChartBarLine
  },
  props: {},
  data () {
    return {
      totalIncomeToday: {},
      projectDetail: {},
      projectEvaluation: {},
      simpleOption: {},
      optionItem: {}
    }
  },
  computed: {},
  methods: {},
  created () {
    this.$service.fetch({
      url: 'api/project/dashboard/1'
    }).then(res => {
      this.totalIncomeToday = res.totalIncomeToday
      this.projectDetail = res.projectDetail
      this.projectEvaluation = res.projectEvaluation
      this.simpleOption = {
        title: res.businessCoreIndicators.title,
        data: {
          data: res.businessCoreIndicators.data,
          links: res.businessCoreIndicators.links
        }
      }
      const data = res.projectCoreIndicators
      const legendData = Object.keys(data.data)
      this.optionItem = {
        title: data.title,
        data: {
          config: {
            xData: data.data[legendData[0]].date,
            legendData: legendData
          },
          data: legendData.map((item, index) => {
            return {
              name: item,
              data: data.data[item].value,
              smooth: true,
              lineStyle: {
                width: 3,
                type: index !== 1 ? 'solid' : 'dashed'
              },
              markArea: !index ? {
                data: [[{
                  xAxis: data.actualVerificationCycleStart,
                  itemStyle: {
                    color: 'rgba(0, 153, 255, .08)'
                  }
                }, {
                  xAxis: data.actualVerificationCycleEnd
                }], [{
                  xAxis: data.planVerificationCycleStart,
                  itemStyle: {
                    color: 'rgba(144, 244, 17, .08)'
                  }
                }, {
                  xAxis: data.planVerificationCycleEnd
                }]]
              } : {}
            }
          })
        }
      }
    })
  }
}
</script>

<style lang="stylus" scoped>
.project-box
  padding 1rem 1.5rem
  height 15.2rem
  .project-tips
    padding-top 1rem
    .project-tips--title
      font-size 1rem
      color #ffffff
      line-height 1.5rem
    .project-tips--content
      line-height 1.9rem
      color rgba(255, 255, 255, .6)
      font-size .9rem
  .project-assessment
    display flex
    .flex
      flex 1
      .flex-header
        height 2rem
        line-height 2rem
        text-align center
        background-image linear-gradient(to left, #1896FF, #005EFF)
        font-size 1rem
        color #ffffff
        border-radius .26rem
    .flex:nth-child(2)
      margin  0 1rem
      .flex-header
        background-image linear-gradient(to left, #05DBCE, #03CAAF)
    .flex:nth-child(3) .flex-header
      background-image linear-gradient(to left, #FFB000, #FF9E00)
    .flex-body
      background #1F1E44
      margin-top .5rem
      border-radius .26rem
      .line
        height 2rem
        line-height 2rem
        display flex
        border-bottom 1px solid rgba(255, 255, 255, .1)
        .lable
          font-size .8rem
          color rgba(255, 255, 255, .6)
          padding-left 1rem
          width 3.8rem
        .value
          flex 1
          font-size .9rem
          color rgba(255, 255, 255, .6)
      .line:last-child
        border 0 none
        .value
          color #F99E49
.main-header
  background #1A1939
  height 3.2rem
  display flex
  padding  0 50px
  .header-left
    font-size 1rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
  .header-right
    height 1.6rem
    padding-top 0.8rem
    opacity .4
.same-day-revenue
  background #1F1E44
  line-height 3rem
  height 3rem
  font-size 1rem
  color #fff
  padding 0 1rem
  border-radius .5rem
  margin-bottom 1rem
  display flex
  .money
    font-size 1.3rem
    font-weight bold
    padding-left 1rem
  .money:before
    content '￥'
    font-size 1rem
  .speed-up
    color #F99E49
    font-size .8rem
    padding-left 1rem
    font-weight bold
    flex 1
    .icon
      font-size 1rem
  .time
    font-size .9rem
    opacity .6
.essential-info
  height 10.2rem
  padding 1.5rem 1rem
  .essential-info--box
    display flex
    line-height 1.35rem
    padding-bottom .6rem
    .lable
      width 5rem
      color rgba(255, 255, 255, .8)
      font-size 1rem
    .value
      flex 1
      font-size .9rem
      color rgba(255, 255, 255, .6)
</style>
